module.exports = __webpack_public_path__ + "static/img/shjg.b3a92300.jpg";